export * from './wifidetails.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/wifidetails/index.ts